import React, { useState } from 'react';
import { CreditCard } from '@phosphor-icons/react';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { useCardTerminal } from '../lib/cardTerminal';

// Status pill + pairing dialog for the PrivaPay/PayTec card terminal (per reception device).
export const CardTerminalButton = () => {
  const t = useCardTerminal();
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState('');
  const [pairing, setPairing] = useState(false);
  if (!t) return null;

  const doPair = async () => {
    if (!code.trim()) return;
    setPairing(true);
    const r = await t.pair(code, 'Padelarena Kasse');
    setPairing(false);
    if (r.ok) { toast.success('Kartenterminal gekoppelt'); setCode(''); setOpen(false); }
    else toast.error(r.error || 'Kopplung fehlgeschlagen');
  };

  const dot = t.connected ? 'bg-emerald-500' : t.paired ? 'bg-amber-500' : 'bg-slate-300';
  const label = t.connected ? 'Terminal verbunden' : t.paired ? 'Terminal getrennt' : 'Terminal koppeln';

  return (
    <>
      <Button variant="outline" size="sm" onClick={() => setOpen(true)} data-testid="card-terminal-btn">
        <span className={`w-2 h-2 rounded-full mr-2 ${dot}`} />
        <CreditCard size={16} className="mr-1" /> {label}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" data-testid="card-terminal-dialog">
          <DialogHeader>
            <DialogTitle>Kartenterminal (PrivaPay)</DialogTitle>
            <DialogDescription>
              Ist ein Terminal gekoppelt, schickt "Karte" den Betrag direkt ans Terminal. Gebucht wird erst nach der Bestätigung. Die Kopplung gilt nur für dieses Gerät.
            </DialogDescription>
          </DialogHeader>
          {t.paired ? (
            <div className="space-y-3">
              <div className="rounded-xl border border-slate-200 p-3 text-sm">
                <p className="font-semibold" data-testid="card-terminal-status">{t.connected ? 'Verbunden' : 'Getrennt – verbindet automatisch neu…'}</p>
                {t.model && <p className="text-slate-500">{t.model}</p>}
                {t.lastError && <p className="text-red-600 text-xs mt-1">{t.lastError}</p>}
              </div>
              <Button variant="outline" className="w-full border-red-200 text-red-600 hover:bg-red-50" data-testid="card-terminal-unpair"
                onClick={() => { if (window.confirm('Terminal von diesem Gerät entkoppeln?')) { t.unpair(); toast.success('Entkoppelt'); } }}>
                Entkoppeln
              </Button>
            </div>
          ) : (
            <div className="space-y-3">
              <ol className="text-sm text-slate-600 list-decimal pl-5 space-y-1">
                <li>Am Terminal das Händlermenü öffnen und "Kopplung starten" wählen.</li>
                <li>Den angezeigten Kopplungscode hier eingeben.</li>
              </ol>
              <Input value={code} onChange={(e) => setCode(e.target.value)} inputMode="numeric" placeholder="Kopplungscode, z.B. 6017087" data-testid="card-terminal-code" />
              <Button className="w-full bg-emerald-600 hover:bg-emerald-700 text-white font-bold" onClick={doPair} disabled={pairing || !code.trim()} data-testid="card-terminal-pair">
                {pairing ? 'Kopple…' : 'Koppeln'}
              </Button>
              <p className="text-[11px] text-slate-400">Voraussetzung: PrivaPay hat am Terminal die Kassenschnittstelle "KIT" aktiviert.</p>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
